import Vue from 'vue';

// When the request succeeds
const success = response => response.data;

// When the request fails
const failed = () => {};

export default user => Vue.$http
    .post('users', user)
    .then(success)
    .catch(failed);



// WEBPACK FOOTER //
// ./src/services/user/create.js